import { FC } from 'react'

import { ResignIcon } from 'assets/icons/resign-icon'

import { finishGameByResign } from 'features/firebase/game-operations'

import { GreenButton, RedButton } from 'shared/components'
import { Dialog, DialogClose, DialogContent, DialogTitle, DialogTrigger } from 'shared/components/ui/dialog'
import { Tooltip, TooltipContent, TooltipTrigger } from 'shared/components/ui/tooltip'

import { useGameContext } from '../game-context'
import { isGameOpen } from '../utils'

export const Resign: FC = () => {
  const {
    game,
    relativeGameData: { playerColor },
  } = useGameContext()

  const resignIcon = <ResignIcon className="h-5 lg:h-10" />

  return (
    <Dialog>
      {!isGameOpen(game.status) ? (
        <RedButton disabled iconLeading={resignIcon} />
      ) : (
        <Tooltip>
          <TooltipTrigger asChild>
            <DialogTrigger asChild>
              <RedButton iconLeading={resignIcon} />
            </DialogTrigger>
          </TooltipTrigger>
          <TooltipContent>Resign</TooltipContent>
        </Tooltip>
      )}
      <DialogContent className="w-11/12 max-w-[850px] rounded-xl p-5">
        <DialogTitle>Are you sure you want to resign?</DialogTitle>
        <DialogClose asChild>
          <div className="flex gap-10">
            <RedButton className="w-full" text="Cancel" />
            <GreenButton
              className="w-full"
              text="Confirm"
              onClick={() => finishGameByResign(game.gameId, playerColor.bottom)}
            />
          </div>
        </DialogClose>
      </DialogContent>
    </Dialog>
  )
}
